import React, { useState } from 'react';
import { ConditionTable } from './pages/ConditionTable';
import { ConditionBoard } from './pages/ConditionBoard';
type ViewMode = 'table' | 'board';
export function App() {
  const [viewMode, setViewMode] = useState<ViewMode>('table');
  return <>
      {viewMode === 'table' ? <ConditionTable onViewModeChange={setViewMode} data-id="element-0" /> : <ConditionBoard onViewModeChange={setViewMode} data-id="element-1" />}
    </>;
}